import { render, staticRenderFns } from "./BlockUI.vue?vue&type=template&id=8d04690a&scoped=true"
import script from "./BlockUI.vue?vue&type=script&lang=js"
export * from "./BlockUI.vue?vue&type=script&lang=js"
import style0 from "./BlockUI.vue?vue&type=style&index=0&id=8d04690a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d04690a",
  null
  
)

export default component.exports